import React from 'react'
import Image from 'next/image'
import styles from './styles.module.css'
import { moneyman } from '../../../assets'

const ReverseImageThree = () => {
  return (
    <div className={styles.imagecontainer}>
      <div className={styles.bigImage}>
        <Image src={moneyman} alt='smiling lady' width={584.5} height={447} />
      </div>
    </div>
  )
}

export default ReverseImageThree
